__turbopack_context__.v({
  "careersWrapper": "blocks-module-scss-module__kxJVya__careersWrapper",
  "home": "blocks-module-scss-module__kxJVya__home",
});
